// extracted by mini-css-extract-plugin
module.exports = {"common-modal":"UploadCSV_common-modal__18lh7","loading-text":"UploadCSV_loading-text__kPFXA"};